import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowRight } from "lucide-react";

const navLinks = [
  { name: "Work", path: "/portfolio" },
  { name: "Services", path: "/prices" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
];

const mobileMenuInitial = { opacity: 0, height: 0 };
const mobileMenuAnimate = { opacity: 1, height: "auto" };
const mobileMenuExit = { opacity: 0, height: 0 };

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#F8F6F3]/95 backdrop-blur-md" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center" data-testid="navbar-logo">
            <span className="text-xl font-black tracking-tight text-[#1C1C1C] uppercase">
              Create Motion
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? "text-[#1C1C1C]"
                    : "text-[#1C1C1C]/50 hover:text-[#1C1C1C]"
                }`}
                data-testid={`nav-link-${link.name.toLowerCase()}`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/contact">
              <button
                className="bg-[#FF5E3A] text-white font-semibold text-sm px-6 py-3 rounded-full hover:bg-[#1C1C1C] transition-colors duration-300 flex items-center gap-2"
                data-testid="navbar-cta"
              >
                Start a Project
                <ArrowRight size={14} />
              </button>
            </Link>
          </div>

          <button
            className="md:hidden text-[#1C1C1C] p-2"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-toggle"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={mobileMenuInitial}
            animate={mobileMenuAnimate}
            exit={mobileMenuExit}
            className="md:hidden bg-[#F8F6F3] border-t border-[#1C1C1C]/5"
            data-testid="mobile-menu"
          >
            <div className="px-6 py-8 space-y-5">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`block text-2xl font-bold ${
                    location.pathname === link.path
                      ? "text-[#FF5E3A]"
                      : "text-[#1C1C1C]"
                  }`}
                  onClick={() => setIsOpen(false)}
                  data-testid={`mobile-nav-link-${link.name.toLowerCase()}`}
                >
                  {link.name}
                </Link>
              ))}
              <Link to="/contact" onClick={() => setIsOpen(false)}>
                <button
                  className="w-full mt-4 bg-[#FF5E3A] text-white font-semibold text-sm px-6 py-4 rounded-full hover:bg-[#1C1C1C] transition-colors duration-300"
                  data-testid="mobile-navbar-cta"
                >
                  Start a Project
                </button>
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
